// Mock Data
export const mentors = [
  { id: 1, name: "Rahul Sharma", role: "Ex-Flipkart VP", expertise: "Product & Growth", image: "👨‍💼", linkedin: "#" },
  { id: 2, name: "Priya Mehta", role: "Angel Investor", expertise: "Fundraising", image: "👩‍💼", linkedin: "#" },
  { id: 3, name: "Vikram Singh", role: "Startup Founder", expertise: "GTM Strategy", image: "👨‍💼", linkedin: "#" },
  { id: 4, name: "Anita Desai", role: "Marketing Director", expertise: "Brand Building", image: "👩‍💼", linkedin: "#" },
];

export const investors = [
  { id: 1, name: "Sequoia Capital India", ticketSize: "₹5-50 Cr", sectors: ["SaaS", "FinTech"], image: "🏢" },
  { id: 2, name: "Accel Partners", ticketSize: "₹2-20 Cr", sectors: ["B2B", "Consumer"], image: "🏢" },
  { id: 3, name: "Matrix Partners", ticketSize: "₹3-25 Cr", sectors: ["EdTech", "HealthTech"], image: "🏢" },
];

export const testimonials = [
  { name: "Amit Kumar", company: "TechStart", text: "GrowthYari helped us close our seed round in 6 weeks!", rating: 5 },
  { name: "Sneha Patel", company: "EduVenture", text: "The mentor network is invaluable. Game-changer for our GTM.", rating: 5 },
  { name: "Rohan Gupta", company: "FinPro", text: "From idea to 10+ investor intros. Worth every rupee!", rating: 5 },
];

export const weeklyProgram = [
  { week: "1-3", title: "Foundation", items: ["Mindset Mastery", "Market Validation", "Investor Storytelling", "Pitch Deck Workshop"] },
  { week: "4-5", title: "Strategy & Brand", items: ["GTM Plan", "CAC/LTV Model", "Brand Positioning", "PR Strategy"] },
  { week: "6-8", title: "Capital & Closure", items: ["Valuation Workshop", "Financial Readiness", "10+ Investor Intros", "Demo Day"] },
];